import { Component, Input, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { get, isEqual, map } from 'lodash';
import { ModelService } from '@services/common/model.service';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent implements ControlValueAccessor {
  @ViewChild('ngSelect', { static: true }) ngSelect: NgSelectComponent;

  @Input() control!: string;
  @Input() placeholder!: string;
  @Input() bindLabel!: string;
  //
  @Input() bindValue: string | null;
  //
  @Input() items!: ModelService<any>;
  @Input() loading = false;

  selected: any;

  constructor(@Self() public controlDir: NgControl) {
    this.controlDir.valueAccessor = this;
  }

  private onChange: (value: any) => void;
  public registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }
  onTouched: () => void;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {
    this.selected = value;
  }

  change(value: any) {
    if (!isEqual(this.selected, value)) {
      this.selected = value;
      this.onChange(value);
    }
  }

  select() {
    if (this.bindValue) {
      const values = map(this.items.model, m => get(m, `${this.bindValue}`));
      this.change(values);
    } else {
      this.change(this.items.model);
    }
  }

  unselect() {
    this.change([]);
  }
}
